'use client'

import { type FC, type PropsWithChildren } from 'react'

import { BigmiProvider, useReconnect } from '@bigmi/react'
import { createDefaultBigmiConfig } from '@lifi/wallet-management'

const { config } = createDefaultBigmiConfig({
    bigmiConfig: {
        ssr: true,
        multiInjectedProviderDiscovery: false,
    },
})

export const UTXOProvider: FC<PropsWithChildren> = ({ children }) => {
    useReconnect(config)

    return (
        <BigmiProvider config={config} reconnectOnMount={false}>
            {children}
        </BigmiProvider>
    )
}
